import { I18n } from "aws-amplify/utils";
import {Typography } from "@mui/material";

export const resourcePrefColumns = [
  {
    id: "fsl_service_resource_account",
    label: I18n.get("Service Resource Account"),
    align: "left",
    flex: 1,
    rendercell: (params) => {
      return (
        <Typography
          component="a"
          href={`https://eptarefrigeration.lightning.force.com/${params.row.fsl_partner_account}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: "medium",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          {params.value}
        </Typography>
      );
    },
  },
  {
    id: "resource_preference_number",
    label: I18n.get("Resource Preference Number"),
    align: "left",
    flex: 1,
    rendercell: (params) => {

      return(
      <Typography
        component="a"
        href={`https://eptarefrigeration.lightning.force.com/${params.row.id}`}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          fontSize: "medium",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        {params.value}
      </Typography>
      )
    }
  },
  {
    id: "fsl_work_type_category",
    label: I18n.get("Work Type Category"),
    align: "left",
    flex: 1,
  },
];
